import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './estilos.css';
import { ProvedorSessao } from './lib/sessao';
import { iniciarPreferencias } from './lib/tema';

iniciarPreferencias();

/*
 * O service worker é o que faz o Levitas abrir sem rede (seção 9.5).
 *
 * Ele registra na abertura, e não só quando a pessoa liga a notificação: quem
 * está no estacionamento da igreja, sem sinal, precisa da escala — e nunca
 * pediu para receber aviso nenhum.
 *
 * Fora do build de produção ele fica de fora: em desenvolvimento, o cache do
 * casco brigaria com o recarregamento a quente do Vite.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // Navegador sem suporte, ou aba anônima: o produto funciona igual, só
      // deixa de abrir sem rede. Não é erro para mostrar a ninguém.
    });
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Elemento #root não encontrado.');

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ProvedorSessao>
        <App />
      </ProvedorSessao>
    </QueryClientProvider>
  </StrictMode>,
);
